import { TemplateRef } from '@angular/core';
import {
  ModelAttributeConfig,
  ModelAttributeDirections,
} from '@zipari/shared-ds-util-configuration';

const numberColumns = 2;

export enum ModelAttributeItemAlignment {
  center = 'center',
  left = 'left',
  right = 'right',
}

export class ModelAttributeConfigWrap {
  configs: ModelAttributeConfig[];
  context?: any = {};
  direction?: ModelAttributeDirections = ModelAttributeDirections.column;
}

export class ContentConfiguration {
  [prop: string]: TemplateRef<any>;
}

export class ModelAttributeGridConfiguration {
  isHorizontal?: boolean = false;

  modelAttribute: ModelAttributeConfigWrap[];

  columns?: number = numberColumns;

  alignItems?: ModelAttributeItemAlignment = ModelAttributeItemAlignment.left;

  heading?: string;

  constructor(options = {}) {
    Object.assign(this, options);
  }
}
